/* ====================== FRAME ===================== */
var editorActive = false;

window.Cookies = window.Cookies = {}

/* ==================  EDITOR LOADER ================ */
var frame = {
  sectionOpen: {
    newsletter : function() { },
    exitintent : function() { }
  },

  sectionClose: {
    newsletter: function() { },
    exitintent: function() { }
  },

  blockOpen: {
    meganav: function(editing, param) {  }
  },

  blockClose: {
    meganav: function(editing, param) {  }
  }
}

/* =================== EDITOR INIT =================== */
/* DO SOMETHING WHEN SECTIONS IS ACTIVE */
$(document).on('shopify:section:load', function(){
  editorActive = true;
});

/* SECTION OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
$(document).on('shopify:section:select', function(evt){
  editorActive = true;

  var sectionName = evt.detail.sectionId;
  if( frame.sectionOpen[sectionName] ){
    frame.sectionOpen[sectionName]();
  }
});

/* SECTION CLOSED: CHECK THE OPEN LIST AND DO SOMETHING */
$(document).on('shopify:section:deselect', function(evt){
  editorActive = true;

  var sectionName = evt.detail.sectionId;
  if( frame.sectionClose[sectionName] ){
    frame.sectionClose[sectionName]();
  }
});

/* BLOCK OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
$(document).on('shopify:block:select', function(evt){
  editorActive = true;

  var sectionName = evt.detail.sectionId,
          blockEl = $(evt.target);

  if( frame.blockOpen[sectionName] ){
    frame.blockOpen[sectionName](blockEl, 'editing');
  }
});

/* BLOCK CLOSED: CHECK THE CLOSED LIST AND DO SOMETHING */
$(document).on('shopify:block:deselect', function(evt){
  editorActive = true;

  var sectionName = evt.detail.sectionId,
          blockEl = $(evt.target);

  if( frame.blockClose[sectionName] ){
    frame.blockClose[sectionName](blockEl, 'close');
  }
});

// window.Frame = window.Frame || {};

/* ================== FRONTEND LOADER ================ */
function themeInit() {
  // CORE MODULE INIT'S
  swatches();

  // CUSTOM MODULE INIT'S
  // newsletterPopup();
};

themeInit();

/* ================= SWATCHES ================= */
function swatches(){
  $(document).ready(function(){
    $('.swatch').on('click', function(){
      $(this).find('input').prop('checked', true).trigger('change');
    });
  });
}
